// extracted by mini-css-extract-plugin
export default {"showMore":"InternalToolCallResults-module__showMore--e17a5"};